import type { Outcome } from '../data/synthetic'

export type SyncPhase = 'synced' | 'saving' | 'offline' | 'error' | 'auth-paused'

export type OwnerDocument<T = unknown> = {
  ownerId: string
  version: number
  savedAt: string
  payload: T
}

export type EntryMutation = {
  id: string
  ownerId: string
  operationId: string
  date: string
  outcome: Outcome | null
  deleted: boolean
  cellKey: string
  clientCreatedAt: string
  clientSequence: number
  deviceId: string
  attempts: number
  state: 'queued' | 'sending' | 'failed'
  lastAttemptAt?: string
  lastErrorCode?: string
}

export type EntryMutationInput = Pick<EntryMutation, 'ownerId' | 'operationId' | 'date'> & {
  id?: string
  outcome?: Outcome | null
  deleted?: boolean
}

export type MutationAcknowledgement = {
  id: string
  cellKey: string
  outcome: Outcome | null
  deleted: boolean
  serverReceivedAt: string
  auditId?: string
  resolution: CellResolution
}

export type CellResolution = {
  cellKey: string
  winnerMutationId: string
  outcome: Outcome | null
  deleted: boolean
  serverReceivedAt: string
  previousWinnerMutationId?: string
}

export type MutationAudit = {
  id: string
  mutationId: string
  cellKey: string
  clientCreatedAt: string
  serverReceivedAt: string
  outcome: Outcome | null
  deleted: boolean
  previousWinnerMutationId?: string
  becameWinner: boolean
}

export type SyncSnapshot = {
  phase: SyncPhase
  pending: number
  lastSyncedAt?: string
  message?: string
}

export type EntryBatchTransport = {
  send(mutations: EntryMutation[]): Promise<MutationAcknowledgement[]>
}

export class SessionExpiredError extends Error {
  constructor(message = 'Your session expired. Sign in again to sync queued changes.') {
    super(message)
    this.name = 'SessionExpiredError'
  }
}

export function entryCellKey(ownerId: string, operationId: string, date: string) {
  return `${ownerId}:${operationId}:${date}`
}
